import * as React from 'react';
import { DayPicker } from 'react-day-picker';
import defaultClassNames from 'react-day-picker/style.module.css';

import { cn } from '@/lib/utils';

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  disabled,
  ...props
}: React.ComponentProps<typeof DayPicker>) {
  const navButtonsClassnames =
    'absolute top-0 flex items-center justify-center opacity-50 hover:opacity-100 rounded-md !border !size-7 [&_svg]:size-4';
  const selectedDayClassnames = 'bg-primary text-primary-foreground rounded-md';

  return (
    <DayPicker
      animate
      navLayout='around'
      disabled={disabled}
      showOutsideDays={showOutsideDays}
      className={cn('p-3', className)}
      classNames={{
        ...defaultClassNames,
        caption_label: 'text-sm font-medium m-auto',
        selected: props.mode === 'range' ? '' : selectedDayClassnames,
        range_start: selectedDayClassnames,
        range_end: selectedDayClassnames,
        range_middle: 'bg-accent text-accent-foreground',
        day_button: 'text-sm font-medium',
        today: 'bg-accent text-accent-foreground rounded-md',
        chevron: 'fill-accent-foreground',
        button_previous: cn(navButtonsClassnames, 'left-0'),
        button_next: cn(navButtonsClassnames, 'right-0'),
        day: cn(defaultClassNames.day, '!size-8'),
        month_caption: cn(defaultClassNames.month_caption, '!h-7 mb-4'),
        ...classNames,
      }}
      {...props}
    />
  );
}

export { Calendar };
